<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exp"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="datajson"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                header-row-class-name="headerclass"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <!-- <el-table-column type="selection"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="countrycode" :label="$t('getapi[12355]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="countryname" :label="$t('getapi[12356]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="days" :label="$t('getapi[7167]')"></el-table-column>
            
            <el-table-column prop="isvalid" :label="$t('getapi[552]')">
                <template slot-scope="scope">
                   {{scope.row.isvalid == 1?$t('getapi[1170]'):$t('getapi[1171]')}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="edit(scope)" type="text" size="small">{{
                        $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[6109]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row>
            <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}
            </div>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%" :close-on-click-modal="false">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('getapi[2020]')">
                    <el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')"
                                         width="150"></el-table-column>
                        <el-table-column :label="$t('getapi[2022]')">
                            <template slot-scope="scope">
                                <input type="text" v-model="scope.row.query_Condition" style="border:none"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[2028]')">
                    <div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div>
                </el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 搜索弹框 -->
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
           
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[12355]')}}</td>
					<td><el-input v-model="formInline.countrycode" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[12356]')}}</td>
					<td><el-input v-model="formInline.countryname" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
                    <td>{{$t('getapi[7167]')}}</td>
					<td><el-input v-model="formInline.days" type="num" size="mini"></el-input></td>
				
                    <td>{{$t('getapi[552]')}}</td>
					<td>
						<el-select filterable v-model="formInline.isvalid"  size="mini">
							<el-option :label="$t('getapi[1170]')" :value="1"></el-option>
                            <el-option :label="$t('getapi[1171]')" :value="0"></el-option>
						</el-select>
					</td>
				</tr>
				<tr>
                    <td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="formInline.remark" type="text" size="mini" ></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small"  @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small"  type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 编辑弹框 -->
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: 'processt',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                formInline: {
                    exclusively_id: 0,
                    countrycode: '',
                    countryname: '',
                    days: 0,
                    isvalid: 1,
                    remark: ''
                },
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: 50,
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                selectData: [],
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                btn: {
                    del: false,
                    edit: false,
                    export: false
                },
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            //this.getqwlist();

        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12353]"),this.$t("getapi[14]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.ReadOnlyRights('plv2', 572, 1)) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
                //操作权
                let ilimits = that.$limits.UnOperationAuthority('plv2', 572, 1);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (ilimits) {
                    case 2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                        break;
                    case 3:
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                        break;
                    default:
                        that.$refs.SetBtn.SetButtonEnable('');
                        break;
                }
            },
            btnauthority(){
              let that = this
              that.btn.export = false
              if(that.selectData.length == 1){
                  that.btn.export = true
              }
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                that.$http.urlpost('Basic/Sale/GetCoTranTimeList', '', function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            sava() {
                let that = this;
                that.loading = true;
                let parm = that.formInline;
                that.$http.urlpost('Basic/Sale/SaveCoTranTime', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        that.editvisi = false;
                    }
                    that.loading = false;
                });
                that.authority();
            },
            
            // 编辑
            edit(jsd) {
                // console.log(jsd);
                this.editvisi = true;
                this.formInline = {
                    exclusively_id: jsd.row.exclusively_id,
                    countrycode: jsd.row.countrycode,
                    countryname: jsd.row.countryname,
                    days: jsd.row.days,
                    isvalid: jsd.row.isvalid,
                    remark: jsd.row.remark
                };
                // console.log(this.formInline);
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].exclusively_id + ',';
                    that.selectData.push(val[i])
                }
                console.log(that.selectIDData);
                that.btnauthority()
            },
            
            // 删除
            del(jsd) {
                let that = this;
                let parm = {
                    Id: jsd.row.exclusively_id
                };
                console.log(parm);
                that.$http.urlpost('Basic/Sale/DeleteCoTranTimeByID', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 新增
            add() {
                let that = this;
                this.editvisi = true;
                that.formInline = {
                    exclusively_id: 0,
                    countrycode: '',
                    countryname: '',
                    days: 0,
                    isvalid: 1,
                    remark: ''
                }
            },
            // 查询
            search() {
                this.isVisible = true;
            },
            // 刷新
            reflash() {
                this.intidata();
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: that.selectIDData,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        query_Condition: item.query_Condition,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //}
                });
                console.log(parm);
                that.$http.urlpost('Basic/Items/WorkCenter_ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            expdetail(flag) {
                let that = this
                let parm = {
                    workproc_name: that.selectData[0].WORKPROC_NAME,
                    flag: flag
                }
                that.$http.urlpost('/Basic/Items/ExportToExecl_RoutDetail', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            getCarftDetail(val){
                let that = this
                console.log(val)
                that.$store.commit('setSharedParams', {
                    key: val
                });
                let item = {
                    label: this.$t("getapi[65]"),
                    name: 'carftview',
                    path: '/carftview',
                    url: '/carftview',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/carftview'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            }
        }
    };
</script>

<style lang="scss" scoped>


table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
